module.exports = __webpack_public_path__ + "img/04-3-1需求调研.1d5aef4a.svg";